import { useEffect, useRef, useState } from "react";

export type StandardSelectOption = {
  value: string;
  label: string;
};

type Props = {
  value: string;
  options: StandardSelectOption[];
  onChange: (value: string) => void;
  className?: string;
};

export function StandardSelect({ value, options, onChange, className = "" }: Props) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement | null>(null);
  const selected = options.find((option) => option.value === value) ?? options[0];

  useEffect(() => {
    const close = (event: MouseEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div className={`pm-select ${className}`} ref={rootRef}>
      <button className="pm-select-trigger" type="button" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
        <span className="pm-select-value">{selected?.label ?? ""}</span>
        <span className="pm-chevron" aria-hidden="true" />
      </button>
      {open ? (
        <div className="pm-select-menu" role="listbox">
          <div className="pm-menu-options">
            {options.map((option) => (
              <button
                className="pm-select-option pm-menu-option"
                type="button"
                role="option"
                aria-selected={option.value === value}
                key={option.value}
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
